import { SETTINGS } from '../../../app.constants';
import { environment } from '../../../../environments/environment';
import { UrlParams } from './url-params.model';

export class Url {

    private _url:string;
    private _queryMode:boolean = false;
    private _queryParams:UrlParams;

    /**
     * 
     * @param relativeEndPointPath (example: goesapp/reference/data/permittedDocuments)
     */
    constructor(path:string, queryParams?:UrlParams, absolutePath:boolean = false){
        
        if(!environment.useStaticAPIData){
            if(!absolutePath){
                this._url = environment.uriEndpoint + path;
            } else {
                this._url = path;
            }
        } else {
            if (!absolutePath) {
                this._url = SETTINGS.staticTestAPIRoot + path;
            } else {
                this._url = path;
            }
        }

        if(queryParams && queryParams.length > 0){
            this._queryMode = true;
            this._queryParams = queryParams;
            this.appendUrlWithParams();
        }

    }

    public toString():string {
        return this._url;
    }

    protected appendUrlWithParams():void {
        let paramsString = this._queryParams.toString();
        this._url += '?' + paramsString; // only url safe params
    }

}

